// react
import { useSelector } from 'react-redux';

// internationalization
import { useTranslation } from 'react-i18next';

// tanstack
import { createFileRoute, useNavigate } from '@tanstack/react-router';

// material ui icons
import AssessmentIcon from '@mui/icons-material/Assessment';

// material ui
import {
  Card,
  Fade,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Typography,
} from '@mui/material';

// api
import { useGetReportsInWorkspaceQuery } from '@/api/power-bi/powerbiApiSlice';

// shared components
import PageContainer from '@/components/layout/PageContainer';
import PageHeader from '@/components/layout/PageHeader';
import GatewayLoadingIndicator from '@/components/ui/progress/GatewayLoadingIndicator';

// components
import { getSelectedAccount } from '@/redux/selectedAccountSlice';
import ErrorBoundary from '@/routes/-ErrorBoundary';

export const Route = createFileRoute('/$accountId/_user/powerbi/')({
  component: RouteComponent,
  errorComponent: ErrorBoundary,
  staticData: { crumb: 'power-bi:title' },
});

function RouteComponent() {
  const { t } = useTranslation('power-bi');
  const navigate = useNavigate();
  const selectedAccount = useSelector(getSelectedAccount);

  const {
    currentData: monitorReports,
    isLoading,
    isError,
  } = useGetReportsInWorkspaceQuery(
    { accountId: selectedAccount.AccountId },
    { skip: !selectedAccount.AccountId },
  );
  return (
    <>
      <GatewayLoadingIndicator isLoading={isLoading} />
      <Fade in={true} timeout={500}>
        <PageContainer maxWidth="xl" sx={{ py: 2 }}>
          <PageHeader title={t('title')} disableArrow={true} />

          {isError && (
            <Typography variant="body2" color="text.secondary">
              {t('noReportsFound')}
            </Typography>
          )}

          {monitorReports && monitorReports.length > 0 && (
            <Card>
              <List>
                {monitorReports.map((report, index) => (
                  <ListItemButton
                    key={report.Id}
                    onClick={() => navigate({ to: `${report.Id}` })}
                    divider={index < monitorReports.length - 1}
                  >
                    <ListItemIcon>
                      <AssessmentIcon color="primary" />
                    </ListItemIcon>
                    <ListItemText primary={report.Name} />
                  </ListItemButton>
                ))}
              </List>
            </Card>
          )}
        </PageContainer>
      </Fade>
    </>
  );
}
